import React, { Component } from 'react';
import { Row, Col, Card, CardHeader, CardBody, Modal, ModalBody, ModalFooter, TabContent, TabPane, FormGroup, Label, Input, InputGroup, InputGroupText, Button, ButtonGroup } from 'reactstrap';
import LaddaButton, { EXPAND_LEFT } from 'react-ladda';
import RichTextEditor from 'react-rte';
import Datetime from 'react-datetime';
import moment from 'moment';

import Config from '../../config';
import Lang from '../../languages';

import AutosuggestInput from './Autosuggest';
import ImageUploader from '../../components/ImageUpload';

import "react-datetime/css/react-datetime.css";
import './Editor.css';

class ProductsEditor extends Component {
 constructor(props) {
  super(props);

  this.state = {
   laddaloading: false,
   errMessage: false,
   editorMode: false,
   productTypes: [],
   productTypesEditor: false,
   productTypesModal: {
    language: this.props.session.language,
    values: {
     [this.props.session.language]: ''
    }
   },
   monthSelector: null,
   languageSelector: Config.defaultLanguage,
   upload: {
    maxFileSize: 5242880,
    imgExtension: [".jpg", ".png", ".webp"],
    defaultImages: []
   }
  }

  this.setValue = this.setValue.bind(this);
  this.handleTabs = this.handleTabs.bind(this);
  this.handleSave = this.handleSave.bind(this);
  this.handleClose = this.handleClose.bind(this);
  this.handleUpload = this.handleUpload.bind(this);
  this.handleTypeCreate = this.handleTypeCreate.bind(this);
  this.handleLanguage = this.handleLanguage.bind(this);
  this.handleName = this.handleName.bind(this);
  this.handleWeekdays = this.handleWeekdays.bind(this);
  this.handleMonthSelect = this.handleMonthSelect.bind(this);
  this.handleTicketAdd = this.handleTicketAdd.bind(this);
  this.handlePacketAdd = this.handlePacketAdd.bind(this);
  this.handleTicketWeekdays = this.handleTicketWeekdays.bind(this);
  this.handlePacketTickets = this.handlePacketTickets.bind(this);
  this.doTicketDelete = this.doTicketDelete.bind(this);
  this.doPacketDelete = this.doPacketDelete.bind(this);

  moment.locale(Lang[this.props.session.language].locale);
 }

 resetAll() {
  var classNames = {}
  var productValues = { type: '', name: { [this.state.languageSelector]: '' }, description: { [this.state.languageSelector]: RichTextEditor.createEmptyValue() }, establishment: '', repetition: 'none', repetitionParams: {}, start_date: moment().startOf('day'), finish_date: moment().startOf('day').add(1, 'day'), pictures: [], tickets: [], packets: [] }
  Object.keys(productValues).map(function (key, value) { classNames[key] = "form-control" });
  this.setState({
   activeTab: '1',
   titleTab: Lang[this.props.session.language].Products.titles.editorTab1,
   laddaloading: false,
   errMessage: false,
   editorMode: false,
   mapZoom: 5,
   product: productValues,
   establishmentName: '',
   classNames
  })
 }

 setValue(e, children) {
  var newProduct = this.state.product;

  if (children === undefined) {
   newProduct[e.target.id] = e.target.value;
   if (e.target.id == 'repetition') {
    switch (e.target.value) {
     case 'daily':
      newProduct.repetitionParams = { repeat_every: 1, until_num: 1, until_unit: 'weeks' }
      break;
     case 'weekly':
      newProduct.repetitionParams = { repeat_every: 1, until_num: 1, until_unit: 'weeks', weekdays: [] }
      break;
     case 'monthly':
      newProduct.repetitionParams = { repeat_every: 1, until_num: 1, until_unit: 'weeks' }
      break;
    }
   }
  } else if (children == 'tickets') {
   newProduct.tickets[e.target.name][e.target.id] = e.target.value;
  } else if (children == 'packets') {
   newProduct.packets[e.target.name][e.target.id] = e.target.value;
  } else {
   newProduct[children][e.target.id] = e.target.value;
  }

  this.setState({ product: newProduct });
 }

 handleTabs(tab) {
  switch (tab) {
   case '1': var title = Lang[this.props.session.language].Products.titles.editorTab1; break;
   case '2': var title = Lang[this.props.session.language].Products.titles.editorTab2; break;
   case '3': var title = Lang[this.props.session.language].Products.titles.editorTab3; break;
   case '4': var title = Lang[this.props.session.language].Products.titles.editorTab4; break;
   case '5': var title = Lang[this.props.session.language].Products.titles.editorTab5; break;
  }

  this.setState({ titleTab: title, activeTab: tab });
 }

 handleSave() {
  var errorFileds = this.state.classNames;
  Object.keys(errorFileds).map(function (key, index) { errorFileds[key] = errorFileds[key].replace(' border border-danger', ''); });
  this.setState({ laddaloading: true, classNames: errorFileds });
  var sendProduct = JSON.parse(JSON.stringify(this.state.product));
  sendProduct.start_date = moment(sendProduct.start_date).format('YYYY-MM-DD HH:mm:ss');
  sendProduct.finish_date = moment(sendProduct.finish_date).format('YYYY-MM-DD HH:mm:ss');
  Object.keys(sendProduct.description).map(language => {
   sendProduct.description[language] = this.state.product.description[language]._cache.html
  })
  this.props.reqAPI(Config.apiURI + '/api/products', 'PUT', sendProduct).then((result) => {
   if (result.success) {
    this.props.onComplete(true);
    this.resetAll();
   } else {
    var errorFileds = this.state.classNames;
    result.failed.map((key) => { errorFileds[key] = errorFileds[key] + " border border-danger"; });
    this.setState({ laddaloading: false, errMessage: result.message, classNames: errorFileds });
   }
  }).catch((error) => {
   console.error(error);
   this.setState({ laddaloading: false });
  })
 }

 handleClose() {
  this.props.handleClose();
  this.resetAll();
 }



 handleUpload(pictures) {
  this.setState({
   ...this.state,
   product: {
    ...this.state.product,
    pictures: pictures
   }
  });
 };

 handleTypeCreate(language, name) {
  var productTypesModal = this.state.productTypesModal;
  if (language) {
   productTypesModal.language = language;
   if (!productTypesModal.values[productTypesModal.language])
    productTypesModal.values[productTypesModal.language] = '';
  }
  if (name) productTypesModal.values[productTypesModal.language] = name;
  this.setState({ productTypesModal });
 }


 handleLanguage(e) {
  var product = this.state.product;
  if (!product.name[e.target.value]) product.name[e.target.value] = '';
  if (!product.description[e.target.value]) product.description[e.target.value] = RichTextEditor.createEmptyValue();
  else product.description[e.target.value] = RichTextEditor.createValueFromString(product.description[e.target.value].toString('html'), "html")
  product.tickets.map((item, key) => {
   if(!product.tickets[key].name[e.target.value]) product.tickets[key].name[e.target.value] = '';
  })
  product.packets.map((item, key) => {
   if(!product.packets[key].name[e.target.value]) product.packets[key].name[e.target.value] = '';
  })

  this.setState({ product, languageSelector: e.target.value });
 }

 handleName(e, parent, key) {
  var product = this.state.product;
  switch(parent) {
   case 'tickets': product.tickets[key].name[this.state.languageSelector] = e.target.value; break;
   case 'packets': product.packets[key].name[this.state.languageSelector] = e.target.value; break;
   default: product.name[this.state.languageSelector] = e.target.value;
  }
  
  this.setState({ product });
 }


 handleWeekdays(key) {
  var newProduct = this.state.product;
  if (typeof newProduct.repetitionParams.weekdays == 'string') {
   newProduct.repetitionParams.weekdays = JSON.parse(newProduct.repetitionParams.weekdays);
  }
  if (newProduct.repetitionParams.weekdays.indexOf(key) < 0) {
   newProduct.repetitionParams.weekdays.push(key);
  } else {
   newProduct.repetitionParams.weekdays.splice(newProduct.repetitionParams.weekdays.indexOf(key), 1);
  }

  this.setState({ product: newProduct });
 }

 handleMonthSelect(e) {
  var newProduct = this.state.product;

  switch (e.target.id) {
   case 'dayofmonth':
    delete newProduct.repetitionParams.weekofmonth;
    delete newProduct.repetitionParams.keeyday
    break;

   case 'weekofmonth':
    delete newProduct.repetitionParams.dayofmonth;
    break;
  }

  this.setState({ monthSelector: e.target.id, product: newProduct });
 }

 handleTicketAdd() {
  var newProduct = this.state.product;
  var hours = Math.abs(newProduct.finish_date - newProduct.start_date) / 36e5;
  newProduct.tickets.push({ name: { [this.state.languageSelector]: '' }, stock: 0, uses_limit: 0, booking_limit: 12, cancellation_limit: 24, validity_time: hours, weekdays: [] })
  this.setState({ product: newProduct });
 }

 handlePacketAdd() {
  var newProduct = this.state.product;
  newProduct.packets.push({ name: { [this.state.languageSelector]: '' }, price: 0, tickets: [] })
  this.setState({ product: newProduct });
 }

 handleTicketWeekdays(index, key) {
  var newProduct = this.state.product;
  if (typeof newProduct.tickets[index].weekdays == 'string') {
   newProduct.tickets[index].weekdays = JSON.parse(newProduct.tickets[index].weekdays);
  }

  if (newProduct.tickets[index].weekdays.indexOf(key) < 0) {
   newProduct.tickets[index].weekdays.push(key);
  } else {
   newProduct.tickets[index].weekdays.splice(newProduct.tickets[index].weekdays.indexOf(key), 1);
  }

  this.setState({ product: newProduct });
 }

 handlePacketTickets(event) {
  var value = parseInt(event.currentTarget.value);
  var product = this.state.product;
  if (event.currentTarget.checked) {
   product.packets[event.currentTarget.id].tickets.push(value);
  } else {
   product.packets[event.currentTarget.id].tickets.splice(product.packets[event.currentTarget.id].tickets.indexOf(value), 1);
  }

  this.setState({ product });
 }


 doTicketDelete(key) {
  var newProduct = this.state.product;
  newProduct.tickets.splice(key, 1);
  newProduct.packets.map((packet, packetKey) => {
   let ticketKey = packet.tickets.indexOf(key);
   if(ticketKey >= 0) newProduct.packets[packetKey].tickets.splice(ticketKey, 1);
  })
  this.setState({ product: newProduct });
 }

 doPacketDelete(key) {
  var newProduct = this.state.product;
  newProduct.packets.splice(key, 1);
  this.setState({ product: newProduct });
 }


 componentWillMount() {
  this.resetAll();
 }

 componentWillUpdate() {
  if (this.state.productTypes.length === 0) {
   this.props.reqAPI(Config.apiURI + '/api/products/types').then(results => {
    if (results.success) {
     var productTypes = [];
     results.items.map((item) => {
      if (item.language === this.props.session.language)
       productTypes.push(item);
     })

     this.setState({ productTypes });
    }
   })
  }

  if (this.props.product != null && !this.state.editorMode) {
   var description = this.props.product.description;
   if (description) {
    Object.keys(description).map((language, key) => {
     description[language] = RichTextEditor.createValueFromString(description[language].toString('html'), 'html')
    })
   } else {
    description = { [this.state.languageSelector]: RichTextEditor.createEmptyValue() }
   }

   var tickets = this.props.product.tickets ? this.props.product.tickets : [];
   tickets.map((item, key) => {
    if (typeof tickets[key].weekdays == 'string')
     tickets[key].weekdays = JSON.parse(tickets[key].weekdays)
   })

   this.setState({
    editorMode: true,
    establishmentName: this.props.product.establishmentName ? this.props.product.establishmentName : '',
    product: {
     ID: this.props.product.ID ? this.props.product.ID : '',
     type: this.props.product.type ? this.props.product.type : '',
     name: this.props.product.name ? this.props.product.name : { [this.props.session.language]: '' },
     description: description,
     establishment: this.props.product.establishment ? this.props.product.establishment : '',
     start_date: this.props.product.start_date ? moment(this.props.product.start_date) : moment().startOf('day'),
     finish_date: this.props.product.finish_date ? moment(this.props.product.finish_date) : moment().startOf('day').add(1, 'day'),
     repetition: this.props.product.repetition ? this.props.product.repetition : 'none',
     repetitionParams: this.props.product.repetition_params ? JSON.parse(this.props.product.repetition_params) : {},
     pictures: this.props.product.pictures ? this.props.product.pictures : [],
     packets: this.props.product.packets ? this.props.product.packets : [],
     tickets
    }
   });
  }
 }


 renderRepetition(repeat) {
  switch (repeat) {

   case 'daily':
    return (
     <FormGroup>
      <Label>{Lang[this.props.session.language].Products.titles.repeat_pattern}</Label>
      <InputGroup>
       <InputGroupText>{Lang[this.props.session.language].Products.titles.repeat_every}</InputGroupText>
       <Input id="repeat_every" placeholder="1" onChange={(e) => this.setValue(e, 'repetitionParams')} value={this.state.product.repetitionParams.repeat_every} />
       <InputGroupText>{Lang[this.props.session.language].Products.titles.days}</InputGroupText>
      </InputGroup>
     </FormGroup>
    );

   case 'weekly':
    return (
     <FormGroup>
      <Label>{Lang[this.props.session.language].Products.titles.repeat_pattern}</Label>
      <InputGroup>
       <InputGroupText>{Lang[this.props.session.language].Products.titles.repeat_every}</InputGroupText>
       <Input id="repeat_every" placeholder="1" onChange={(e) => this.setValue(e, 'repetitionParams')} value={this.state.product.repetitionParams.repeat_every} />
       <InputGroupText>{Lang[this.props.session.language].Products.titles.weeks}</InputGroupText>
      </InputGroup>

      <ButtonGroup className="mt-2 mx-auto">
       <InputGroupText className="mr-2">{Lang[this.props.session.language].Products.titles.repeat_weekdays}</InputGroupText>
       {
        moment.weekdaysShort(true).map((day, key) => {
         return (<Button key={key + 1} color="primary" outline onClick={() => this.handleWeekdays(key + 1)} active={this.state.product.repetitionParams.weekdays.includes(key + 1)}>{day}</Button>)
        })
       }
      </ButtonGroup>
     </FormGroup>
    );

   case 'monthly':
    return (
     <FormGroup>
      <Label>{Lang[this.props.session.language].Products.titles.repeat_pattern}</Label>
      <InputGroup>
       <InputGroupText>{Lang[this.props.session.language].Products.titles.repeat_every}</InputGroupText>
       <Input id="repeat_every" placeholder="1" onChange={(e) => this.setValue(e, 'repetitionParams')} value={this.state.product.repetitionParams.repeat_every} />
       <InputGroupText>{Lang[this.props.session.language].Products.titles.months}</InputGroupText>
      </InputGroup>

      <InputGroup className="mt-2">
       <InputGroupText>
        <Input addon type="radio" id="dayofmonth" name="monthselect" onChange={this.handleMonthSelect} checked={this.state.monthSelector == 'dayofmonth'} />
       </InputGroupText>
       <InputGroupText>{Lang[this.props.session.language].Products.titles.repeat_onday}</InputGroupText>
       <Input id="dayofmonth" placeholder="2" onChange={(e) => this.setValue(e, 'repetitionParams')} value={this.state.product.repetitionParams.dayofmonth} disabled={this.state.monthSelector != 'dayofmonth'} />
       <InputGroupText>{Lang[this.props.session.language].Products.titles.repeat_daymonth}</InputGroupText>
      </InputGroup>

      <InputGroup className="mt-2">
       <InputGroupText>
        <Input addon type="radio" id="weekofmonth" name="monthselect" onChange={this.handleMonthSelect} checked={this.state.monthSelector == 'weekofmonth'} />
       </InputGroupText>
       <InputGroupText>{Lang[this.props.session.language].Products.titles.repeat_the}</InputGroupText>
       <Input id="weekofmonth" type="select" onChange={(e) => this.setValue(e, 'repetitionParams')} value={this.state.product.repetitionParams.weekofmonth} disabled={this.state.monthSelector != 'weekofmonth'}>
        <option value="first">{Lang[this.props.session.language].Products.titles.repeat_select.first}</option>
        <option value="second">{Lang[this.props.session.language].Products.titles.repeat_select.second}</option>
        <option value="third">{Lang[this.props.session.language].Products.titles.repeat_select.third}</option>
        <option value="fourth">{Lang[this.props.session.language].Products.titles.repeat_select.fourth}</option>
        <option value="last">{Lang[this.props.session.language].Products.titles.repeat_select.last}</option>
       </Input>
       <Input id="weekday" name="select" type="select" onChange={(e) => this.setValue(e, 'repetitionParams')} value={this.state.product.repetitionParams.weekday} disabled={this.state.monthSelector != 'weekofmonth'}>
        {
         moment.weekdays(true).map((day, key) => {
          return (<option key={key} value={key}>{day}</option>)
         })
        }
       </Input>
      </InputGroup>
     </FormGroup>
    );

   default:
    return null;
  }
 }


 render() {
  if (this.state.product === null) {
   return (<div />)
  } else {
   switch (this.state.activeTab) {
    case '1': var tabIcon = 'fa fa-calendar'; break;
    case '2': var tabIcon = 'fa fa-qrcode'; break;
    case '3': var tabIcon = 'fa fa-ticket'; break;
    case '4': var tabIcon = 'fa fa-picture-o'; break;
   }
   return (
    <Modal className="modal-xl ModalProduct" isOpen={this.props.open}>
     <CardHeader>
      <i className={tabIcon}></i><strong>{this.state.titleTab}</strong>
      <select id="language" value={this.state.languageSelector} onChange={this.handleLanguage} className="ml-2">
       {
        Object.keys(Lang[this.props.session.language].languages).map((key, index) => {
         return (<option key={index} value={key}>{Lang[this.props.session.language].languages[key]}</option>)
        })
       }
      </select>
      <div className="card-actions bg-light">
       <Button disabled={this.state.activeTab !== '1' ? false : true} onClick={() => this.handleTabs('1')}><i className="fa fa-calendar"></i></Button>
       <Button disabled={this.state.activeTab !== '2' ? false : true} onClick={() => this.handleTabs('2')}><i className="fa fa-qrcode"></i></Button>
       <Button disabled={this.state.activeTab !== '3' ? false : true} onClick={() => this.handleTabs('3')}><i className="fa fa-ticket"></i></Button>
       <Button disabled={this.state.activeTab !== '4' ? false : true} onClick={() => this.handleTabs('4')}><i className="fa fa-picture-o"></i></Button>
      </div>
     </CardHeader>

     <ModalBody>

      <TabContent activeTab={this.state.activeTab}>
       <TabPane tabId="1">

       <FormGroup row>
         <Col xs="5">
          <FormGroup className="form-group-clean">
           <Label htmlFor="name">{Lang[this.props.session.language].Products.columns.name}</Label>
           <Input id="name" type="text" autoComplete="off" value={this.state.product.name[this.state.languageSelector]} onChange={this.handleName} placeholder={Lang[this.props.session.language].Products.placeholders.name} className={this.state.classNames.name} />
          </FormGroup>
         </Col>

         <Col xs="3">
          <FormGroup className="form-group-clean">
           <Label htmlFor="type">{Lang[this.props.session.language].Products.columns.type}</Label>
           <InputGroup>
            <Input id="type" name="select" type="select" onChange={this.setValue} value={this.state.product.type} className={this.state.classNames.type}>
             <option></option>
             {
              this.state.productTypes ? this.state.productTypes.map((type) => {
               return (<option key={type.ID} value={type.ID}>{type.name}</option>)
              }) : null
             }
            </Input>
            <Button color="primary" outline onClick={() => this.setState({ productTypesEditor: true })}><i className="fa fa-plus"></i></Button>
           </InputGroup>
          </FormGroup>
          <Modal className="modal-lg" isOpen={this.state.productTypesEditor} keyboard={false}>
           <ModalBody>
             <InputGroup>
              <Input type="select" style={{width:'8%'}} onChange={(e) => this.handleTypeCreate(e.target.value, false)} value={this.state.productTypesModal.language}>
               {
                Object.keys(Lang[this.props.session.language].languages).map((key, index) => {
                 return (<option key={index} value={key}>{Lang[this.props.session.language].languages[key]}</option>)
                })
               }
              </Input>
              <Input type="text" style={{width:'77%'}} onChange={(e) => this.handleTypeCreate(false, e.target.value)} value={this.state.productTypesModal.values[this.state.productTypesModal.language]} placeholder={Lang[this.state.productTypesModal.language].Products.placeholders.typeadd} />
              <ButtonGroup style={{width:'15%'}}>
              <Button className="ml-1" color="danger" outline onClick={() => {
               var productTypesModal = this.state.productTypesModal;
               productTypesModal.language = this.props.session.language;
               Object.keys(productTypesModal.values).map((lang, key) => { productTypesModal.values[lang] = '' });
               this.setState({ productTypesEditor: false, productTypesModal });
              }}><i className="fa fa-solid fa-close"></i></Button>
              <Button className="ml-1" color="success" outline onClick={() => {
               this.props.reqAPI(Config.apiURI + '/api/products/types', 'POST', this.state.productTypesModal.values).then((result) => {
                if (result.success) {
                 var product = this.state.product;
                 var productTypes = this.state.productTypes;
                 var productTypesModal = this.state.productTypesModal;
                 product.type = result.ID;
                 productTypes.push({ID: result.ID, language: this.props.session.language, name: this.state.productTypesModal.values[this.props.session.language]});
                 productTypesModal.language = this.props.session.language;
                 Object.keys(productTypesModal.values).map((lang, key) => { productTypesModal.values[lang] = '' });
                 this.setState({ product, productTypes, productTypesEditor: false, productTypesModal })
                }
               }).catch((error) => {
                console.error(error);
               })
              }}><i className="fa fa-solid fa-check"></i></Button>
             </ButtonGroup>
             </InputGroup>
           </ModalBody>
          </Modal>
         </Col>

         <Col xs="2">
          <FormGroup className="form-group-clean">
           <Label htmlFor="start_date">{Lang[this.props.session.language].Products.columns.start_date}</Label>
           <Datetime id="start_date" locale={Lang[this.props.session.language].locale} dateFormat={Lang[this.props.session.language].dateFormat} timeFormat={Lang[this.props.session.language].timeFormat} onChange={(date) => this.setValue({ target: { id: 'start_date', value: date } })} value={this.state.product.start_date} inputProps={{ className: this.state.classNames.start_date }} />
          </FormGroup>
         </Col>

         <Col xs="2">
          <FormGroup className="form-group-clean">
           <Label htmlFor="finish_date">{Lang[this.props.session.language].Products.columns.finish_date}</Label>
           <Datetime id="finish_date" locale={Lang[this.props.session.language].locale} dateFormat={Lang[this.props.session.language].dateFormat} timeFormat={Lang[this.props.session.language].timeFormat} onChange={(date) => this.setValue({ target: { id: 'finish_date', value: date } })} value={this.state.product.finish_date} inputProps={{ className: this.state.classNames.finish_date }} />
          </FormGroup>
         </Col>
        </FormGroup>

        <FormGroup row>
         <Col xs="6">
          <FormGroup className="form-group-clean">
           <Label htmlFor="description">{Lang[this.props.session.language].Products.columns.description}</Label>
           <RichTextEditor
            className="RichTextEditor rounded-0"
            toolbarClassName="pb-0 px-2 pt-2 m-0"
            editorClassName=""
            value={this.state.product.description[this.state.languageSelector]}
            onChange={(value) => {
             value.toString('html');
             var newProduct = this.state.product;
             newProduct.description[this.state.languageSelector] = value;
             this.setState({ product: newProduct });
            }}
            toolbarConfig={{
             display: ['INLINE_STYLE_BUTTONS', 'BLOCK_TYPE_BUTTONS', 'LINK_BUTTONS', 'BLOCK_TYPE_DROPDOWN', 'HISTORY_BUTTONS'],
             INLINE_STYLE_BUTTONS: [
              { label: 'Bold', style: 'BOLD', className: 'custom-css-class' },
              { label: 'Italic', style: 'ITALIC' },
              { label: 'Underline', style: 'UNDERLINE' }
             ],
             BLOCK_TYPE_DROPDOWN: [
              { label: 'Normal', style: 'unstyled' },
              { label: 'Heading Large', style: 'header-one' },
              { label: 'Heading Medium', style: 'header-two' },
              { label: 'Heading Small', style: 'header-three' }
             ],
             BLOCK_TYPE_BUTTONS: [
              { label: 'UL', style: 'unordered-list-item' },
              { label: 'OL', style: 'ordered-list-item' }
             ]
            }}
           />
          </FormGroup>
         </Col>
         <Col xs="6">
          <FormGroup className="form-group-clean">
           <Label htmlFor="establishment">{Lang[this.props.session.language].Products.columns.establishment}</Label>
           <AutosuggestInput {...this.props} value={this.state.establishmentName} handleCallback={(establishment) => {
            var newProduct = this.state.product;
            newProduct.establishment = establishment ? establishment.ID : null;
            this.setState({ product: newProduct, establishmentName: establishment.name });
           }} placeholder={Lang[this.props.session.language].Products.placeholders.establishment} className={this.state.classNames.establishment} />
          </FormGroup>

          <FormGroup className="form-group-clean mt-2">
           <Label for="repetition">{Lang[this.props.session.language].Products.titles.repetition}</Label>
           <Input id="repetition" name="select" type="select" onChange={this.setValue} value={this.state.product.repetition} className={this.state.classNames.repetition}>
            <option value="none">{Lang[this.props.session.language].Products.columns.repetition.none}</option>
            <option value="daily">{Lang[this.props.session.language].Products.columns.repetition.daily}</option>
            <option value="weekly">{Lang[this.props.session.language].Products.columns.repetition.weekly}</option>
            <option value="monthly">{Lang[this.props.session.language].Products.columns.repetition.monthly}</option>
           </Input>
          </FormGroup>
          {this.renderRepetition(this.state.product.repetition)}
          {
           this.state.product.repetition == 'none' ? null :
            <FormGroup className="form-group-clean mt-2">
             <Label>{Lang[this.props.session.language].Products.titles.repeat_end}</Label>
             <InputGroup>
              <InputGroupText>{Lang[this.props.session.language].Products.titles.repeat_time}</InputGroupText>
              <Input id="until_num" placeholder="1" value={this.state.product.repetitionParams.until_num} onChange={(e) => this.setValue(e, 'repetitionParams')} />
              <Input id="until_unit" type="select" value={this.state.product.repetitionParams.until_unit} onChange={(e) => this.setValue(e, 'repetitionParams')} style={{ width: '90px' }}>
               <option value="days">{Lang[this.props.session.language].Products.titles.days}</option>
               <option value="weeks">{Lang[this.props.session.language].Products.titles.weeks}</option>
               <option value="months">{Lang[this.props.session.language].Products.titles.months}</option>
               <option value="years">{Lang[this.props.session.language].Products.titles.years}</option>
              </Input>
              <InputGroupText>{Lang[this.props.session.language].Products.titles.repeat_from}</InputGroupText>
             </InputGroup>
            </FormGroup>
          }
         </Col>
        </FormGroup>
       </TabPane>


       <TabPane tabId="2">
        <Button color="success" style={{ margin: '0px auto 10px auto' }} onClick={this.handleTicketAdd}><i className="fa fa-plus"></i> {Lang[this.props.session.language].Products.buttons.addTicket}</Button>

        {
         this.state.product.tickets.map((ticket, key) => {
          return (
           <FormGroup key={key} row className="pl-3 mb-1">
            <FormGroup className="form-group-clean">
             {key == 0 ? <Label htmlFor="name">{Lang[this.props.session.language].Products.columns.tickets.name}</Label> : null}
             <InputGroup>
              <InputGroupText className="mr-1"><i className="fa fa-qrcode"></i></InputGroupText>
              <Input id="name" name={key} type="text" autoComplete="off" style={{ width: '200px' }} value={this.state.product.tickets[key].name[this.state.languageSelector]} onChange={(e) => this.handleName(e, 'tickets', key)} placeholder={Lang[this.props.session.language].Products.placeholders.tickets.name} className={this.state.classNames.name} />
             </InputGroup>
            </FormGroup>
            <FormGroup className="form-group-clean">
             {key == 0 ? <Label htmlFor="stock">{Lang[this.props.session.language].Products.columns.tickets.stock}</Label> : null}
             <Input id="stock" name={key} type="text" autoComplete="off" style={{ width: '60px' }} value={this.state.product.tickets[key].stock} onChange={(e) => this.setValue(e, 'tickets')} className={this.state.classNames.stock} />
            </FormGroup>
            <FormGroup className="form-group-clean">
             {key == 0 ? <Label htmlFor="uses_limit">{Lang[this.props.session.language].Products.columns.tickets.uses_limit}</Label> : null}
             <Input id="uses_limit" name={key} type="text" autoComplete="off" style={{ width: '50px' }} value={this.state.product.tickets[key].uses_limit} onChange={(e) => this.setValue(e, 'tickets')} className={this.state.classNames.uses_limit} />
            </FormGroup>
            <FormGroup className="form-group-clean">
             {key == 0 ? <Label htmlFor="booking_limit">{Lang[this.props.session.language].Products.columns.tickets.booking_limit}</Label> : null}
             <InputGroup>
              <Input id="booking_limit" name={key} type="text" autoComplete="off" style={{ width: '50px' }} value={this.state.product.tickets[key].booking_limit} onChange={(e) => this.setValue(e, 'tickets')} className={this.state.classNames.booking_limit} />
              <InputGroupText>{Lang[this.props.session.language].Products.titles.hours}</InputGroupText>
             </InputGroup>
            </FormGroup>
            <FormGroup className="form-group-clean">
             {key == 0 ? <Label htmlFor="cancellation_limit">{Lang[this.props.session.language].Products.columns.tickets.cancellation_limit}</Label> : null}
             <InputGroup>
              <Input id="cancellation_limit" name={key} type="text" autoComplete="off" style={{ width: '50px' }} value={this.state.product.tickets[key].cancellation_limit} onChange={(e) => this.setValue(e, 'tickets')} className={this.state.classNames.cancellation_limit} />
              <InputGroupText>{Lang[this.props.session.language].Products.titles.hours}</InputGroupText>
             </InputGroup>
            </FormGroup>
            <FormGroup className="form-group-clean">
             {key == 0 ? <Label htmlFor="validity_time">{Lang[this.props.session.language].Products.columns.tickets.validity_time}</Label> : null}
             <InputGroup>
              <Input id="validity_time" name={key} type="text" autoComplete="off" style={{ width: '50px' }} value={this.state.product.tickets[key].validity_time} onChange={(e) => this.setValue(e, 'tickets')} className={this.state.classNames.validity_time} />
              <InputGroupText>{Lang[this.props.session.language].Products.titles.hours}</InputGroupText>
             </InputGroup>
            </FormGroup>
            <FormGroup className="form-group-clean">
             {key == 0 ? <Label htmlFor="weekdays">{Lang[this.props.session.language].Products.columns.tickets.weekdays}</Label> : null}
             <InputGroup>
              <ButtonGroup className="mx-auto">
               {
                moment.weekdaysShort(true).map((day, weekkey) => {
                 return (<Button key={weekkey + 1} color="primary" className="px-2" outline onClick={() => this.handleTicketWeekdays(key, weekkey + 1)} active={this.state.product.tickets[key].weekdays.includes(weekkey + 1)}>{day}</Button>)
                })
               }
              </ButtonGroup>
             </InputGroup>
            </FormGroup>
            <FormGroup className="form-group-clean">
             {key == 0 ? <Label dangerouslySetInnerHTML={{ __html: "&nbsp" }}></Label> : null}
             <InputGroup>
              <Button color="danger" style={{ margin: '0px 0px 0px 5px' }} onClick={() => this.doTicketDelete(key)}><i className="fa fa-trash"></i></Button>
             </InputGroup>
            </FormGroup>
           </FormGroup>
          )
         })
        }
       </TabPane>

       <TabPane tabId="3">
        <Button color="success" style={{ margin: '0px auto 10px auto' }} onClick={this.handlePacketAdd}><i className="fa fa-plus"></i> {Lang[this.props.session.language].Products.buttons.addPacket}</Button>

        {
         this.state.product.packets.map((packet, packetKey) => {
          return (
           <Card key={packetKey}>
            <CardHeader className="p-1">
             <Row>
              <Col xs="9">
               <InputGroup>
                <InputGroupText style={{ margin: '0px 10px 0px -10px' }}><i className="fa fa-ticket"></i></InputGroupText>
                <Input id="name" name={packetKey} type="text" autoComplete="off" value={this.state.product.packets[packetKey].name[this.state.languageSelector]} onChange={(e) => this.handleName(e, 'packets', packetKey)} placeholder={Lang[this.props.session.language].Products.placeholders.packets.name} />
               </InputGroup>
              </Col>
              <Col xs="3">
               <InputGroup>
                <InputGroupText>{Lang[this.props.session.language].Products.columns.packets.price}:</InputGroupText>
                <Input id="price" name={packetKey} type="text" autoComplete="off" value={this.state.product.packets[packetKey].price} onChange={(e) => this.setValue(e, 'packets')} placeholder={Lang[this.props.session.language].Products.placeholders.packets.price} />
                <Button color="danger" style={{ margin: '0px 0px 0px 5px' }} onClick={() => this.doPacketDelete(packetKey)}><i className="fa fa-trash"></i></Button>
               </InputGroup>
              </Col>
             </Row>
            </CardHeader>
            <CardBody className="p-2">
             {
              this.state.product.tickets.map((ticket, ticketKey) => {
               return (
                <FormGroup key={ticketKey} check inline>
                 <Label check>
                  <Input id={packetKey} type="checkbox" name="ticket" checked={this.state.product.packets[packetKey].tickets.indexOf(ticketKey) >= 0} value={ticketKey} onChange={this.handlePacketTickets} /> {ticket.name[this.state.languageSelector]}
                 </Label>
                </FormGroup>
               )
              })
             }
            </CardBody>
           </Card>

          )
         })
        }
       </TabPane>

       <TabPane tabId="4">
        <ImageUploader
         withIcon={true}
         withLabel={true}
         withPreview={true}
         buttonText={Lang[this.props.session.language].Products.buttons.uploadPhoto}
         fileSizeError={"File size is too big!"}
         fileTypeError={"This extension is not supported!"}
         onChange={this.handleUpload}
         imgExtension={this.state.imgExtension}
         maxFileSize={this.state.maxFileSize}
         defaultImages={this.state.product.pictures}
        />
       </TabPane>

      </TabContent>
     </ModalBody>

     <ModalFooter>
      <div className="text-danger"><strong>{this.state.errMessage}</strong></div>
      <Button color="danger" onClick={this.handleClose}>{Lang[this.props.session.language].Products.buttons.closeEditor}</Button>
      <LaddaButton
       type="submit"
       onClick={this.handleSave}
       className="btn btn-success btn-ladda"
       data-style={EXPAND_LEFT}
       loading={this.state.laddaloading}>
       {this.state.editorMode ? Lang[this.props.session.language].Products.buttons.saveChanges : Lang[this.props.session.language].Products.buttons.createBtn}
      </LaddaButton>
     </ModalFooter>
    </Modal>
   )
  }
 }

}

export default ProductsEditor;



// WEBPACK FOOTER //
// ./websources/views/Products/Editor.js